import React from "react";
import { Component } from "react";
import { Clock } from "react-feather";
import user from "views/ilearn/ilearndetails/img/usericon2.png";
import EnrollmentOptions from "views/ilearn/ilearndetails/components/EnrollmentOptions";
class IlearnInstructors extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="my-14">
        <div>
          <h1 className="fsize28 font-bold uppercase">Instructors</h1>

          <div className="flex mt-8">
            <div className="w-1/2 divider-r-EBEBEB">
              <div className="flex items-center">
                <img src={user} alt="user" className="h-88px w-88px" />
                <div className="pl-6">
                  <h2 className="text-black font-semibold fsize18">
                    Dr. Tracy Bear
                  </h2>
                  <p className="text424B5A fsize18">Assistant Professor</p>
                  <div class="flex justify-start items-center lg:mt-4 md:mt-4">
                    <div class="flex items-center mr-2">
                      <p class="fsize18 text-black font-semibold">
                        298,704{" "}
                        <span className=" text424B5A font-normal">
                          Learners
                        </span>
                      </p>
                    </div>
                    <div class="flex items-center">
                      <span class="dot-point bg-E77817 rounded-full mx-2"></span>
                      <p class="fsize18 text-black font-semibold">
                        298,704{" "}
                        <span className=" text424B5A font-normal">
                          Learners
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-1/2 flex justify-center">
              <div className="flex items-center">
                <img src={user} alt="user" className="h-88px w-88px" />
                <div className="pl-6">
                  <h2 className="text-black font-semibold fsize18">
                    Dr. Tracy Bear
                  </h2>
                  <p className="text424B5A fsize18">Assistant Professor</p>
                  <div class="flex justify-start items-center lg:mt-4 md:mt-4">
                    <div class="flex items-center mr-2">
                      <p class="fsize18 text-black font-semibold">
                        298,704{" "}
                        <span className=" text424B5A font-normal">
                          Learners
                        </span>
                      </p>
                    </div>
                    <div class="flex items-center">
                      <span class="dot-point bg-E77817 rounded-full mx-2"></span>
                      <p class="fsize18 text-black font-semibold">
                        298,704{" "}
                        <span className=" text424B5A font-normal">
                          Learners
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="divider-b-EBEBEB py-8"></div>
          <div className="pt-12">
            <h1 className="fsize28 font-bold uppercase">Syllabus</h1>
            <div className="flex mt-8 mb-16">
              <div className="w-1/5">
                <div>
                  <p className="fsize18 font-medium ">WEEK</p>
                  <h1 className="font-semibold fsize56 text-black">1</h1>
                </div>
              </div>
              <div className="w-4/5	">
                <div className="syllabus">
                  <div className="flex items-center">
                    <div className="bgF7F7F7 rounded-full p-2">
                      <Clock className="text053C6D" svgClasses="w-2 h-2" />
                    </div>

                    <p className="fsize18 font-semibold text-black pl-4">
                      2 hours to complete
                    </p>
                  </div>

                  <div className="mt-6">
                    <h1 className="fsize24 font-bold text262626">Worldview</h1>
                    <p className="text707070 fsize16 line-24 pt-4">
                      In this introductory module, students learn the
                      significance of stories and storytelling in Indigenous
                      societies. We explore history that comes from Indigenous
                      worldviews, this includes worldviews from the Inuit,
                      Nehiyawak, Kanien:keha’ka and Tlingit peoples.
                    </p>
                    <p className="uppercase fsize16 font-semibold textE77817 pt-3">
                      SEE ALL
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex mb-16">
              <div className="w-1/5">
                <div>
                  <p className="fsize18 font-medium ">WEEK</p>
                  <h1 className="font-semibold fsize56 text-black">2</h1>
                </div>
              </div>
              <div className="w-4/5	">
                <div className="syllabus">
                  <div className="flex items-center">
                    <div className="bgF7F7F7 rounded-full p-2">
                      <Clock className="text053C6D" svgClasses="w-2 h-2" />
                    </div>

                    <p className="fsize18 font-semibold text-black pl-4">
                      2 hours to complete
                    </p>
                  </div>

                  <div className="mt-6">
                    <h1 className="fsize24 font-bold text262626">Worldview</h1>
                    <p className="text707070 fsize16 line-24 pt-4">
                      In this introductory module, students learn the
                      significance of stories and storytelling in Indigenous
                      societies. We explore history that comes from Indigenous
                      worldviews, this includes worldviews from the Inuit,
                      Nehiyawak, Kanien:keha’ka and Tlingit peoples.
                    </p>
                    <p className="uppercase fsize16 font-semibold textE77817 pt-3">
                      SEE ALL
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex mb-16">
              <div className="w-1/5">
                <div>
                  <p className="fsize18 font-medium ">WEEK</p>
                  <h1 className="font-semibold fsize56 text-black">3</h1>
                </div>
              </div>
              <div className="w-4/5	">
                <div className="syllabus">
                  <div className="flex items-center">
                    <div className="bgF7F7F7 rounded-full p-2">
                      <Clock className="text053C6D" svgClasses="w-2 h-2" />
                    </div>

                    <p className="fsize18 font-semibold text-black pl-4">
                      2 hours to complete
                    </p>
                  </div>

                  <div className="mt-6">
                    <h1 className="fsize24 font-bold text262626">Worldview</h1>
                    <p className="text707070 fsize16 line-24 pt-4">
                      In this introductory module, students learn the
                      significance of stories and storytelling in Indigenous
                      societies. We explore history that comes from Indigenous
                      worldviews, this includes worldviews from the Inuit,
                      Nehiyawak, Kanien:keha’ka and Tlingit peoples.
                    </p>
                    <p className="uppercase fsize16 font-semibold textE77817 pt-3">
                      SEE ALL
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex mb-16">
              <div className="w-1/5">
                <div>
                  <p className="fsize18 font-medium ">WEEK</p>
                  <h1 className="font-semibold fsize56 text-black">4</h1>
                </div>
              </div>
              <div className="w-4/5	">
                <div className="syllabus">
                  <div className="flex items-center">
                    <div className="bgF7F7F7 rounded-full p-2">
                      <Clock className="text053C6D" svgClasses="w-2 h-2" />
                    </div>

                    <p className="fsize18 font-semibold text-black pl-4">
                      2 hours to complete
                    </p>
                  </div>

                  <div className="mt-6">
                    <h1 className="fsize24 font-bold text262626">Worldview</h1>
                    <p className="text707070 fsize16 line-24 pt-4">
                      In this introductory module, students learn the
                      significance of stories and storytelling in Indigenous
                      societies. We explore history that comes from Indigenous
                      worldviews, this includes worldviews from the Inuit,
                      Nehiyawak, Kanien:keha’ka and Tlingit peoples.
                    </p>
                    <p className="uppercase fsize16 font-semibold textE77817 pt-3">
                      SEE ALL
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex ">
              <div className="w-1/5">
                <div>
                  <p className="fsize18 font-medium ">WEEK</p>
                  <h1 className="font-semibold fsize56 text-black">5</h1>
                </div>
              </div>
              <div className="w-4/5	">
                <div className="syllabus">
                  <div className="flex items-center">
                    <div className="bgF7F7F7 rounded-full p-2">
                      <Clock className="text053C6D" svgClasses="w-2 h-2" />
                    </div>

                    <p className="fsize18 font-semibold text-black pl-4">
                      2 hours to complete
                    </p>
                  </div>

                  <div className="mt-6">
                    <h1 className="fsize24 font-bold text262626">Worldview</h1>
                    <p className="text707070 fsize16 line-24 pt-4">
                      In this introductory module, students learn the
                      significance of stories and storytelling in Indigenous
                      societies. We explore history that comes from Indigenous
                      worldviews, this includes worldviews from the Inuit,
                      Nehiyawak, Kanien:keha’ka and Tlingit peoples.
                    </p>
                    <p className="uppercase fsize16 font-semibold textE77817 pt-3">
                      SEE ALL
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="divider-b-EBEBEB py-8"></div>
            <EnrollmentOptions />
          </div>
        </div>
      </div>
    );
  }
}
export default IlearnInstructors;
